/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { fabric } from "fabric";
import UploadIcon from "@material-ui/icons/CloudUpload";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";

import Button from "@material-ui/core/Button";
import { throttle } from "underscore";
import Masonry from "./MasonryLayout";
import DeskpadImage from "../../editor/image";
import Thumb from "./UploaderThumb";
import { useStoreon } from "storeon/react";
import { pixelToMm } from "./UploaderThumb";
import PerfectScrollbar from "react-perfect-scrollbar";
import confirm from "components/Dialog";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Switch from "@material-ui/core/Switch";

import t from "../../translations";

const imagePlaceholder =
  "data:image/png;base64,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";

const UploadAgreement = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
`;

const UploadFormats = styled.div`
  text-align: center;
  border: 2px dashed white;
  padding: 8px;
  margin-bottom: 8px;
`;

const dropzoneCss = css`
  outline: none !important;
  color: white;
  height: 100%;
  img.preview {
    max-width: 100%;
  }
  .clickToUpload {
    text-align: center;
    margin-bottom: 10px;
    svg {
      margin-right: 5px;
    }
  }
  .drophere {
    background: #04acffc4;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    z-index: 9999;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    > svg {
      height: 2em;
      width: 2em;
      margin: 5px 0;
    }
    > div {
      font-size: 18px;
      margin: 5px 0;
      &.desc {
        font-size: 14px;
      }
    }
  }
`;

const getImageSize = img => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = function() {
      resolve({ width: this.width, height: this.height });
    };
    image.src = img;
  });
};

const updateFileData = (files, key, ext) =>
  files.map(file => {
    if (file.key === key) {
      const updatedFile = { ...file, ...ext };
      return updatedFile;
    }
    return file;
  });

const Uploader = props => {
  const [files, setFiles] = useState([]);
  const [accepted, setAccepted] = useState(false);
  const { dispatch, canvas, uploadPool, editorType, config, isAdmin } = useStoreon(
    "canvas",
    "isAdmin",
    "uploadPool",
    "editorType",
    "config"
  );

  const maxUploadSize = config.maxUploadSize ? config.maxUploadSize : 50;

  const uploadFile = fileToUpload => {
    const formData = new FormData();
    formData.append("file", fileToUpload);
    if (editorType === "printplate") {
      formData.append("printplate", true);
    }
    dispatch("uploadPool/setProgress", { file: fileToUpload.key, progress: 0 });
    const key = fileToUpload.key;
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if(window?.DeskpadData?.nonce !== undefined && window?.DeskpadData?.nonce !== null){
      headers["X-WP-Nonce"] = window.DeskpadData.nonce;
    }
    axios
      .post("/wp-json/dpe/v1/gallery/upload", formData, {
        headers: headers,
        onUploadProgress: throttle(progressEvent => {
          const { total, loaded } = progressEvent;
          const percent = loaded / total;
          dispatch("uploadPool/setProgress", {
            file: fileToUpload.key,
            progress: percent
          });
        }, 50)
      })
      .then(resp => {
        console.info("Upload image", resp.data);
        if (!resp.data.image) {
          setFiles(files =>
            updateFileData(files, key, { error: resp.data.error })
          );
          dispatch(
            "notification/error",
            `Can't upload image. Reason: ${resp.data.error}`
          );
        } else {
          const { image } = resp.data;
          const ext = { image: image, preview: image.sizes.thumb.file };
          setFiles(files => updateFileData(files, key, ext));
          dispatch("notification/success", t.imageUploadSuccessful);
        }
      })
      .catch(err => {
        setFiles(files => updateFileData(files, key, { error: err.message }));
        dispatch("notification/error", err.message);
      });
  };

  const onDrop = async (acceptedFiles, rejectedFiles) => {
    if (!accepted) {
      dispatch("notification/error", window.DeskpadContent.uploadAgreement);
      return;
    }
    if (rejectedFiles?.length) {
      dispatch("notification/error", `${t.uploaderFormats} - ${maxUploadSize}Mb`);
      return;
    }
    window._paq?.push(["trackEvent", "Uploads", "Uploaded files", undefined, acceptedFiles?.length]);
    const promises = acceptedFiles.map(async file => {
      const generatePreviweFor = ["image/jpeg", "image/png"];
      let preview = imagePlaceholder;
      if (generatePreviweFor.includes(file.type) && file.size < 10 * 1024 * 1024) {
        preview = window.URL.createObjectURL(file);
      }
      const imageSize = await getImageSize(preview);
      return Object.assign(file, {
        preview,
        imageSize,
        image: {
          attachmentType: editorType === "printplate" ? "printplate" : undefined
        },
        key: Math.random()
      });
    });

    const newFiles = await Promise.all(promises);
    setFiles(files => [...files, ...newFiles]);
    newFiles.forEach(file => {
      uploadFile(file);
    });
  };

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    maxSize: maxUploadSize * 1024 * 1024,
    onDrop,
    accept:
      "image/*,application/postscript, application/pdf, application/octet-stream"
  });

  useEffect(() => {
    const headers = {};
    if(window?.DeskpadData?.nonce !== undefined && window?.DeskpadData?.nonce !== null){
      headers["X-WP-Nonce"] = window.DeskpadData.nonce;
    }
    axios
      .get("/wp-json/dpe/v1/gallery/upload", {headers: headers})
      .then(resp => {
        if (resp.data.images !== undefined) {
          setFiles(resp.data.images);
        } else {
          console.error("Wrong session images format", resp.data);
        }
      })
      .catch(err => {
        console.error("Session images get failed", err);
      });
  }, []);

  useEffect(() => {
    return () => {
      files.forEach(file => window.URL.revokeObjectURL(file.preview));
    };
  }, [files]);

  const handleDelete = async file => {
    if (!file.image) {
      return;
    }
    const result = await confirm.show({
      icon: <DeleteForeverIcon style={{ marginRight: 10 }} />,
      title: t.removeUpload
    });
    if (!result) {
      return;
    }
    try {
      window._paq?.push(["trackEvent", "Uploads", "Upload removed"]);
      const headers = {};
      if(window?.DeskpadData?.nonce !== undefined && window?.DeskpadData?.nonce !== null){
        headers["X-WP-Nonce"] = window.DeskpadData.nonce;
      }
      const resp = axios.delete("/wp-json/dpe/v1/gallery/upload", {
        headers: headers,
        data: { hash: file.image.hash }
      });
      console.info("Remove upload", resp.data);
      setFiles(files =>
        files.filter(f => {
          if (!f.image) return true;
          if (f.image.hash === file.image.hash) {
            return false;
          }
          return true;
        })
      );
    } catch (err) {
      console.error("Remove upload failed", err);
    }
  };

  const handleUploadedImageClick = file => {
    if (file.image.attachmentType === "printplate") {
      //FIXME: move cutline width (3mm) to global cofig or backend endpoint
      const order = {
        uploaded: true,
        image: file.image,
        size: {
          width: pixelToMm(file.imageSize.width) - 6,
          height: pixelToMm(file.imageSize.height) - 6
        },
        preview: file.image.sizes.large.file
      };
      canvas.DPE.printplate.addOrder(order);
      return;
    }
    if (!file.image || !file.image.hash) {
      return;
    }
    const image = file.image.sizes.original;
    new DeskpadImage(file.image.sizes.large.file).loadOnCanvas(
      canvas,
      {
        width: image.width,
        height: image.height,
        hash: file.image.hash,
        isVector: file.image.isVector
      },
      file.image.sizes.thumb.file,
      true
    );
    window._paq?.push(["trackEvent", "Uploads", "Upload added"]);
  };

  const filesToDisplay = files.filter(file => {
    if (!file.image) {
      return false;
    }
    if (
      editorType === "printplate" &&
      file.image.attachmentType === "printplate"
    ) {
      return file;
    }
    if (
      (editorType === "printfile" || editorType === "collage") &&
      file.image.attachmentType !== "printplate"
    ) {
      return file;
    }
    return false;
  });

  const handleAgreementChange = event => setAccepted(!accepted);

  const processTemplateFile = e => {
    var url = URL.createObjectURL(e.target.files[0]);
    fabric.loadSVGFromURL(url, function(objects, options) {
      objects.forEach(function(svg) {
        const maskColor = "#aaaa00";
        svg.generateId();
        svg.mask = true;
        svg.borderColor = maskColor;
        svg.cornerColor = maskColor;
        svg.cornerStrokeColor = maskColor;
        const k = 0.35;
        svg.scaleX *= k;
        svg.scaleY *= k;
        svg.top *= k;
        svg.left *= k;

        svg.top += 0;
        svg.left += 0;
        canvas.add(svg);
        svg.setCoords();
      });
    });
  };

  return (
    <div
      {...getRootProps({ onClick: event => event.stopPropagation() })}
      css={dropzoneCss}
    >
      <input {...getInputProps()} />
      <PerfectScrollbar>
        <div className="clickToUpload">
          <UploadAgreement>
            <Switch onClick={handleAgreementChange} checked={accepted} />
            <div
              dangerouslySetInnerHTML={{
                __html: window.DeskpadContent.uploadAgreement
              }}
            ></div>
          </UploadAgreement>
          <Button
            variant="contained"
            color="secondary"
            onClick={open}
            fullWidth
            disabled={!accepted}
          >
            <UploadIcon />
            {t.clickToUpload}
          </Button>
          {isAdmin && (
            <React.Fragment>
              <input
                accept="image/svg+xml"
                id="contained-button-file"
                type="file"
                onChange={processTemplateFile}
                style={{ display: "none" }}
                onClick={e => {
                  e.target.value = "";
                }}
              />
              <label htmlFor="contained-button-file">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginTop: 15 }}
                  component="span"
                >
                  Upload SVG template
                </Button>
              </label>
            </React.Fragment>
          )}
        </div>

        <UploadFormats>{t.uploaderFormats}</UploadFormats>
        <Masonry columns={2} gap={5}>
          {filesToDisplay.map(file => {
            return (
              <Thumb
                progress={uploadPool[file.key]}
                file={file}
                key={file.key}
                keyForLayout={file.key}
                onDelete={handleDelete}
                onClick={handleUploadedImageClick}
              />
            );
          })}
        </Masonry>
      </PerfectScrollbar>
      {isDragActive && accepted && (
        <div className="drophere">
          <UploadIcon />
          <div>{t.dropToUploadYourImage}</div>
          <div className="desc">{t.uploaderFormats}</div>
        </div>
      )}
    </div>
  );
};

export default Uploader;
